import { applyMask } from '../../../../services/utils'

export default function formatLoanAmount(value?: number | null) {
	return `$${applyMask(value || 0, 'fullCurrency')}`
}
